export default function imagePlaceholderHover() {
    const imagePlaceholders = document.querySelectorAll('.image-placeholder');

    if(!imagePlaceholders) {
        return;
    }

    imagePlaceholders.forEach((imagePlaceholder) => {
        imagePlaceholder.addEventListener('mouseenter', (e) => {
            imagePlaceholder.classList.add('hovered');
        });
    });
}